import React, { useCallback, useContext } from 'react';
import { useIsSmallScreen } from '../../../../../../../Hooks/useFullscreenView';
import EDIconButton from '../../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import EDButton from '../../../../../../../BaseComponents/Buttons/Button/EDButton';
import EDIcon from '../../../../../../../BaseComponents/Icon/EDIcon';
import { UserQuery_node_TEDSYSUser__Associations_Franvaro_All } from '../../Queries/_QueryTypes/UserQuery';
import { FranvaroContext } from '../../Context/FranvaroContext/FranvaroContext';

interface IProps {
  setEditFranvaro: React.Dispatch<
    React.SetStateAction<
      undefined | UserQuery_node_TEDSYSUser__Associations_Franvaro_All
    >
  >;
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const AddFranvaroButton: React.FC<IProps> = props => {
  const franvaroContext = useContext(FranvaroContext);
  const isSmallScreen = useIsSmallScreen();

  const onClick = useCallback(() => {
    franvaroContext.setEditFranvaro(undefined);
    franvaroContext.setFranvaroReservID(null);
    franvaroContext.setRegisterFranvaroDialogOpen(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isSmallScreen ? (
        <EDIconButton
          color="primary"
          icon="add"
          margin="none"
          onClick={onClick}
          padding="dense"
          tooltip="Lägg till ny Frånvaroperiod"
          testId="reserv-add"
        />
      ) : (
        <EDButton
          color="primary"
          flat
          icon={<EDIcon iconType="add" color="primary" />}
          onClick={onClick}
          testId="reserv-add"
        >
          Lägg till ny frånvaroperiod
        </EDButton>
      )}
    </>
  );
};

export default AddFranvaroButton;
